﻿window.cObjetThreadIaFichewebMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Recherche web MIA"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle recherche web MIA"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined') { txt = "Recherche web MIA" }
        else { txt = objet.data.question_str }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fafa fafa-mia' title='Recherche web MIA' style='position:relative'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='font-size:60%;position:absolute;bottom:-5px;right:-5px;'></i></i>")
    }


    this.contentTemplatePopup = function (contentElement, option) {
        if (typeof option == 'undefined') option = {}
        contentElement.empty();
        $("<div/>").appendTo(contentElement).dxCtrlRechercheMiaFicheWeb({
            bddCtrl: objet.bddRef,
            id_thread_ia_ficheweb: objet.data.id_thread_ia_ficheweb
        }).dxCtrlRechercheMiaFicheWeb("instance")
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var d = dataTemplate
        var importee = !!d.d_import || (d.nb_import || 0) > 0 || d.etape == "import"
        var $Cible = $(contentElement).closest(".divtemplate")
        if ($Cible.length == 0) $Cible = $(contentElement)
        $Cible.toggleClass("texture_import_disable_projet_pipeline", importee)

        var $Table = $("<table style='table-layout:fixed;width:100%;border-collapse:collapse;line-height:1.1;'/>").appendTo(contentElement)

        // ---------- ligne 1 : avatar (sur les 2 lignes) + question ----------
        var $Tr1 = $("<tr/>").appendTo($Table)
        var $TdUti = $("<td rowspan='2' style='width:30px;padding:0 3px;vertical-align:middle;'/>").appendTo($Tr1)
        var idUti = d.id_utilisateur
        if (idUti == null) idUti = 99999
        $("<div style='width:24px;height:24px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: idUti,
            text: objet.bddRef.getObjet("utilisateur", idUti).mGetLib1()
        })
        var question = d.question_str || d.nom || "(recherche vide)"
        $("<td style='white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'/>")
            .text(question).attr("title", question).appendTo($Tr1)

        // ---------- ligne 2 : où en est la recherche ----------
        var libEtape = {
            estimation: "Estimation", structures: "Recherche des structures", validation: "Sélection des structures",
            contacts: "Recherche des contacts", "import": "Importée"
        }[d.etape] || ""
        var libStatut = { en_cours: "en cours", termine: "", arrete: "arrêtée", erreur: "en erreur" }[d.statut]
        var morceaux = []
        if (libEtape) morceaux.push(libEtape + (libStatut ? " " + libStatut : ""))
        else if (libStatut) morceaux.push(libStatut)
        if (d.nb_str) morceaux.push(d.nb_str + " structure" + (d.nb_str > 1 ? "s" : "") +
            (d.nb_str_valide ? " (" + d.nb_str_valide + " retenue" + (d.nb_str_valide > 1 ? "s" : "") + ")" : ""))
        if (d.nb_con) morceaux.push(d.nb_con + " contact" + (d.nb_con > 1 ? "s" : ""))
        if (importee) morceaux.push((d.nb_import ? d.nb_import + " importée" + (d.nb_import > 1 ? "s" : "") : "importée") +
            (d.d_import ? " le " + new Date(d.d_import).toLocaleDateString("fr-FR") : ""))
        if (morceaux.length == 0) morceaux.push("Pas encore lancée")
        var detail = morceaux.join(" • ")

        var $Tr2 = $("<tr/>").appendTo($Table)
        var $TdDetail = $("<td style='white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-family:barlow condensed;font-size:12px;opacity:0.6;'/>")
            .text(detail).attr("title", detail).appendTo($Tr2)
        if (d.statut == "erreur") $TdDetail.css({ color: "#c0392b", opacity: 1 })
        else if (d.statut == "arrete") $TdDetail.css({ color: "#e67e22", opacity: 1 })
        else if (d.statut == "en_cours") $TdDetail.css({ color: "#2980b9", opacity: 1 })
    }

}